// @owners { team: patients-team }
import { AltoIcon, PresentationListItem } from '@alto/design-system';
import React from 'react';
import { deliveryMethodString } from '~shared/features/delivery-info/helpers/getShipmentWithItemsRowProps';
import { isCourier, isMail, isPickup } from '~shared/helpers/order';
import { type ShipmentMethod } from '~shared/types';

type DeliveryMethodProps = {
  readonly method?: ShipmentMethod;
};

export const DeliveryMethodRow = ({ method }: DeliveryMethodProps) => {
  if (!method) {
    return null;
  }

  if (isCourier(method)) {
    return (
      <PresentationListItem
        data-testid="delivery-method-row"
        LeftContent={
          <AltoIcon
            name="car"
            type="grey"
          />
        }
        text="Arrives via courier"
      />
    );
  }
  if (isMail(method)) {
    return (
      <PresentationListItem
        data-testid="delivery-method-row"
        LeftContent={
          <AltoIcon
            name="box"
            type="grey"
          />
        }
        text={`Ships via ${deliveryMethodString[method]}`}
      />
    );
  }
  if (isPickup(method)) {
    return (
      <PresentationListItem
        data-testid="delivery-method-row"
        LeftContent={
          <AltoIcon
            name="handbox"
            type="grey"
          />
        }
        text="Pick up"
      />
    );
  }

  return null;
};
